import { ETypoColor } from "@Front/Components/DesignSystem/Typography";

type IProps = {
	color?: ETypoColor;
};

export default function Check(props: IProps): React.JSX.Element {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15 4.5L6.75 12.75L3 9"
				stroke={`var(--${props.color ?? "white"})`}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
